// ========= START: src/components/WelcomeScreen.js (NEW FILE) =========
import React from 'react';
import Background from './Background';
import './WelcomeScreen.css'; // We will create this CSS file next

function WelcomeScreen({ onStart }) {
  return (
    <div className="welcome-screen">
      <Background background={{ type: 'video', src: `${process.env.PUBLIC_URL}/assets/backgrounds/main_background.mp4` }} />
      <div className="welcome-content">
        <img 
          src={`${process.env.PUBLIC_URL}/assets/logo/bp-echo-logo.png`} 
          alt="BP Shout Logo" 
          className="welcome-logo" 
        />
        <div className="start-buttons-container">
          <img
            src={`${process.env.PUBLIC_URL}/assets/menu-buttons/start-button-shout.png`}
            alt="Start Pronunciation Challenge"
            className="start-button-image"
            onClick={onStart}
          />
        </div>
        <a href="https://bplabo.jp" className="back-to-hub-button">↩️ LABO Hub</a>
      </div>
    </div>
  );
}

export default WelcomeScreen;
// ========= END: src/components/WelcomeScreen.js (NEW FILE) =========